import { render } from "./areaManage.vue?vue&type=template&id=a4a7cd5a&scoped=true"
import script from "./areaManage.vue?vue&type=script&lang=js"
export * from "./areaManage.vue?vue&type=script&lang=js"

import "./areaManage.vue?vue&type=style&index=0&id=a4a7cd5a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4a7cd5a"]])

export default __exports__